import * as yup from 'yup';
import { ChangeBillingAddressPayload } from './BillingAddressForm';

export const billingAddressSchema = yup.object<ChangeBillingAddressPayload>({
  firstName: yup
    .string().max(100, 'Max. 100 characters')
    .required('This field is required'),
  lastName: yup
    .string().max(70, 'Max. 70 characters')
    .required('This field is required'),
  street: yup
    .string().max(512, 'Max. 512 characters')
    .required('This field is required'),
  postalCode: yup.string().max(128, 'Max. 128 characters')
    .matches(/^[0-9]*$/, 'Area Code can only contain numbers').required('This field is required'),
  city: yup.string().max(128, 'Max. 128 characters').required('This field is required'),
  country: yup.string().required('This field is required'),
  institution: yup.string().max(128, 'Max. 128 characters').notRequired()
});
